function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StateHandler, controllerMixin } from 'oskari-ui/util';
import { TimeseriesMetadataService } from '../../service/TimeseriesMetadataService';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
var _getStartTimeFromYear = function _getStartTimeFromYear(year) {
  if (!year) {
    return null;
  }
  return dayjs.utc(year.toString(), 'YYYY').startOf('year');
};
var _getEndTimeFromYear = function _getEndTimeFromYear(year) {
  if (!year) {
    return null;
  }
  return dayjs.utc(year.toString(), 'YYYY').endOf('year');
};
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(delegate, stateListener) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this._delegate = delegate;
    _this._layer = delegate.getLayer();
    var hasMetadata = _this._initMetadataLayer(_this._layer);
    _this._timer = null;
    _this._debounceTime = 300;
    _this._shouldAutoSelectMidDataYear = true;
    var _delegate$getYearRang = delegate.getYearRange(),
      _delegate$getYearRang2 = _slicedToArray(_delegate$getYearRang, 2),
      start = _delegate$getYearRang2[0],
      end = _delegate$getYearRang2[1];
    var dataYears = hasMetadata ? [] : _this._getDataYearsFromWMS();
    _this.state = {
      title: _this._layer.getName(),
      start: start,
      end: end,
      mode: 'year',
      value: start,
      dataYears: dataYears
    };
    _this.addStateListener(stateListener);
    delegate.onDestroy(function () {
      return _this._teardown();
    });
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "setInitialValue",
    value: function setInitialValue(value, mode) {
      // no need to auto select mid data year if an initial
      // value is provided through e.g. map link or map view
      this._shouldAutoSelectMidDataYear = false;
      this.updateValue(value, mode);
    }
  }, {
    key: "updateValue",
    value: function updateValue(value, mode) {
      var _this2 = this;
      var state = {
        value: value
      };
      if (mode) {
        state.mode = mode;
      }
      this.updateState(state);
      if (this._timer) {
        clearTimeout(this._timer);
      }
      this._timer = setTimeout(function () {
        return _this2._requestNewTime(value);
      }, this._debounceTime);
    }
  }, {
    key: "setCurrentViewportBbox",
    value: function setCurrentViewportBbox(bbox, zoomLevel) {
      var _this3 = this;
      if (!this._metadataHandler) {
        return;
      }
      if (this._metadataHandler.getToggleLevel() > zoomLevel) {
        var dataYears = this._getDataYearsFromWMS();
        this._autoSelectMidDataYear(dataYears);
        this.updateState({
          dataYears: dataYears,
          error: false
        });
        return;
      }
      this.updateState({
        error: false,
        loading: true
      });
      this._metadataHandler.setBbox(bbox, function (dataYears) {
        _this3._autoSelectMidDataYear(dataYears);
        _this3.updateState({
          dataYears: dataYears,
          loading: false
        });
        var _this3$_getTimeRange = _this3._getTimeRange(),
          _this3$_getTimeRange2 = _slicedToArray(_this3$_getTimeRange, 2),
          start = _this3$_getTimeRange2[0],
          end = _this3$_getTimeRange2[1];
        _this3._updateFeaturesByTime(start, end);
      }, function (error) {
        _this3.updateState({
          error: true,
          loading: false
        });
        Oskari.log('TimeSeries').warn('Error updating features', error);
      });
    }
  }, {
    key: "_autoSelectMidDataYear",
    value: function _autoSelectMidDataYear(dataYears) {
      if (!this._shouldAutoSelectMidDataYear || !dataYears.length) {
        return;
      }
      this._shouldAutoSelectMidDataYear = false;
      var value = dataYears[Math.ceil(dataYears.length / 2)];
      this.updateValue(value);
    }
  }, {
    key: "_teardown",
    value: function _teardown() {
      if (!this._metadataHandler) {
        return;
      }
      this._metadataHandler.clearPreviousFeatures();
    }
  }, {
    key: "_initMetadataLayer",
    value: function _initMetadataLayer(layer) {
      if (!layer) {
        return false;
      }
      var options = layer.getOptions() || {};
      var timeseries = options.timeseries || {};
      var metadata = timeseries.metadata || {};
      var layerId = metadata.layer;
      if (!layerId) {
        return false;
      }
      var attribute = metadata.attribute || 'time';
      this._metadataHandler = new TimeseriesMetadataService(layerId, attribute, metadata.toggleLevel, !!metadata.visualize);
      return true;
    }
  }, {
    key: "_getDataYearsFromWMS",
    value: function _getDataYearsFromWMS() {
      // get years from WMS-layer timeseries
      var times = this._layer.getAttributes().times;
      return times.map(function (time) {
        return dayjs(time).year();
      });
    }
  }, {
    key: "_requestNewTime",
    value: function _requestNewTime(value) {
      var startYear = null;
      var endYear = null;
      if (Array.isArray(value)) {
        startYear = value[0];
        endYear = value[1];
      } else {
        startYear = value;
        endYear = value;
      }
      var startTime = _getStartTimeFromYear(startYear);
      var endTime = _getEndTimeFromYear(endYear);
      if (!startTime || !endTime) {
        return null;
      }
      var newTime = "".concat(startTime.toISOString(), "/").concat(endTime.toISOString());
      this._delegate.requestNewTime(newTime);
      this._updateFeaturesByTime(startTime, endTime);
    }
  }, {
    key: "_updateFeaturesByTime",
    value: function _updateFeaturesByTime(start, end) {
      if (!this._metadataHandler) {
        return;
      }
      this._metadataHandler.showFeaturesForRange(start, end);
    }
  }, {
    key: "_getTimeRange",
    value: function _getTimeRange() {
      var _this$getState = this.getState(),
        value = _this$getState.value;
      var startYear = null;
      var endYear = null;
      if (value.length === 2) {
        startYear = value[0];
        endYear = value[1];
      } else {
        startYear = value;
        endYear = value;
      }
      return [_getStartTimeFromYear(startYear), _getEndTimeFromYear(endYear)];
    }
  }]);
}(StateHandler);
export var TimeSeriesRangeControlHandler = controllerMixin(UIHandler, ['updateValue', 'setCurrentViewportBbox']);